// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/** Euro formatter for aggregate money values (AUM etc.) — whole euros. */
export const eurFormatter = new Intl.NumberFormat('en-IE', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

/** Format an AUM value; zero/absent renders as an em dash. */
export function formatAum(value?: number | null): string {
  if (value === undefined || value === null || value === 0) return '—';
  return eurFormatter.format(value);
}
